import React from 'react';

import { SvgIcon } from '@mui/material';
import { NAV_COLOR_PALETTE } from '../../Components/styleConstants';
import { DATA_TEST, getDynamicDataTestId } from '../../enums';
import { StringSVGComponent } from './StringSVGComponent';
import { TRAY_BUTTON_ICONS } from './TrayControllerButton';

export interface IConditionalIconRendererProps {
  utilityName: string;
  customMuiIcon?: typeof SvgIcon;
  stringIcon?: string;
}

export const ConditionalIconRenderer = ({ customMuiIcon, stringIcon, utilityName }: IConditionalIconRendererProps) => {
  const IconComponent = customMuiIcon || TRAY_BUTTON_ICONS[utilityName];

  // If the customMuiIcon is not a valid MUI Icon component, throw an error
  // It can also be a wrapped react svg component coming from react-capital-assets therefore a function is acceptable
  if (customMuiIcon && typeof IconComponent !== 'object' && typeof IconComponent !== 'function') {
    console.error('customMuiIcon must be a valid MUI Icon component');
  }

  return (
    <>
      {/* If the IconComponent is a function then it is a wrapped react svg component coming from react-capital-assets. If it is of type object then it is a custom MUI Icon */}
      {!stringIcon && (typeof IconComponent === 'function' || typeof IconComponent === 'object') && (
        <IconComponent fontSize="small" data-test={getDynamicDataTestId(DATA_TEST.tray_option_mui_icon, utilityName)} />
      )}
      {/* If IconComponent is undefined and stringIcon prop is present render the custom svg string */}
      {stringIcon && !IconComponent && (
        <StringSVGComponent
          svgString={stringIcon}
          color={NAV_COLOR_PALETTE.secondaryGray}
          dataTest={getDynamicDataTestId(DATA_TEST.tray_option_custom_icon, utilityName)}
        />
      )}
    </>
  );
};
